import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ClientRequestsIcon from "@mui/icons-material/PersonAdd";
import AlarmIcon from "@mui/icons-material/Alarm";
import ClientsIcon from "@mui/icons-material/People";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Clients from "./clients/Clients";
import Requests from "./clients/Requests";
import Reminders from "./clients/Reminders";
import { useEffect, useState } from "react";
import { api, routes } from "../../utils/constants";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeUser, setUser } from "../../store/slices/userSlice";
import { updateUser as updateUsersListUser } from "../../store/slices/usersSlice";
import SettingsIcon from "@mui/icons-material/Settings";
import SupportIcon from "@mui/icons-material/Support";
import LogoutIcon from "@mui/icons-material/Logout";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CircularProgress from "@mui/material/CircularProgress";
import useUserAvatar from "../../hooks/useUserAvatar";
import { cacheAvatarBlob, clearAvatarCache } from "../../utils/avatarCache";
import { GET, DELETE, UPLOAD, PATCH, removeLocalAccessTokenAndUser } from "../../configs/api";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Jobs from "./jobs/Jobs";
import JobsIcon from "@mui/icons-material/Construction";
import Users from "./users/Users";
import UsersIcon from "@mui/icons-material/ManageAccounts";
import Technicians from "./technicians/Technicians";
import TechniciansIcon from "@mui/icons-material/Engineering";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { setClients, getClientRequests } from "../../store/slices/clientsSlice";
import { syncClientColors } from "../../utils/clientColors";
import { getUser } from "../../store/slices/userSlice";
import { clearSelectedCompany, getSelectedCompanyName, getSelectedCompanyId } from "../../store/slices/tenantSlice";
import { Avatar, Tooltip, Badge, Switch, useTheme, Chip, AppBar, Toolbar, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import BusinessIcon from "@mui/icons-material/Business";
import { setUsers, removeUsers } from "../../store/slices/usersSlice";
import { removeClients } from "../../store/slices/clientsSlice";
import {
    canAccessAccounting,
    canAccessUsersPage,
    canAccessRequestsPage,
    canAccessPendingJobsTab,
    canAccessProposalsTab,
    canAccessPartRequestsTab,
    canAccessJobUnlockRequestsTab,
    canViewDashboard,
    canViewControlCenter,
    canManageAlerts,
    canAccessClientsPage,
    isManagement,
    canViewDeletedJobs,
    isSuperAdmin,
    allRoleLabels,
} from "../../utils/permissions";
import Dashboard from "./dashboard/Dashboard";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ControlCenter from "./controlCenter/ControlCenter";
import HubIcon from "@mui/icons-material/Hub";
import { removeJobs, setJobs } from "../../store/slices/jobsSlice";
import DeployLogsDialog from "../../components/DeployLogsDialog";
import LinkIcon from "@mui/icons-material/Link";
import Map from "./map/Map";
import MapIcon from "@mui/icons-material/Map";
import Calendar from "./calendar/Calendar";
import CalendarIcon from "@mui/icons-material/CalendarToday";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Notifications from "./notifications/Notifications";
import CampaignIcon from "@mui/icons-material/Campaign";
import Alerts from "./alerts/Alerts";
import { LoadScript } from "@react-google-maps/api";
import { toggleTheme } from "../../store/slices/themeSlice";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { getJobs } from "../../store/slices/jobsSlice";
import { deriveJobTechnicianRequestRows, deriveUnassignedPendingJobRows, deriveProposalRequestRows, derivePartRequestRows, deriveJobUnlockRequestRows, deriveMyRequestRows } from "../../utils/jobTechnicianRequests";
import { fetchNotifications, getUnreadCount, clearNotifications } from "../../store/slices/notificationsSlice";
import {
    fetchAccountingTabCounts,
    getAccountingTabCounts,
    clearAccountingTabCounts,
} from "../../store/slices/accountingCountsSlice";
import Accounting from "./Accounting/Accounting";
import Settings from "./settings/Settings";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import MobileBottomNav from "../../components/MobileBottomNav";
import useIsMobile from "../../hooks/useIsMobile";
import {
    MOBILE_BOTTOM_TABS_CHANGED_EVENT,
    resolveBottomTabs,
} from "../../utils/mobileBottomTabs";

const GOOGLE_MAPS_LIBRARIES = ['places'];
const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(9)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
        width: `calc(${theme.spacing(10)} + 1px)`,
    },
});

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    overflow: "visible",
}));

const Drawer = styled(MuiDrawer)(({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    variants: [
        {
            props: ({ open }) => open,
            style: {
                ...openedMixin(theme),
                "& .MuiDrawer-paper": {
                    ...openedMixin(theme),
                    background: theme.palette.mode === 'dark' ? theme.palette.background.paper : "#eeeeee",
                    border: "none",
                    borderRight: theme.palette.mode === 'dark' ? `1px solid ${theme.palette.divider}` : "1px solid #d0d0d0",
                    borderLeft: "none",
                    color: theme.palette.text.primary,
                    overflow: "visible",
                },
            },
        },
        {
            props: ({ open }) => !open,
            style: {
                ...closedMixin(theme),
                "& .MuiDrawer-paper": {
                    ...closedMixin(theme),
                    background: theme.palette.mode === 'dark' ? theme.palette.background.paper : "#eeeeee",
                    border: "none",
                    borderRight: theme.palette.mode === 'dark' ? `1px solid ${theme.palette.divider}` : "1px solid #d0d0d0",
                    borderLeft: "none",
                    color: theme.palette.text.primary,
                    overflow: "visible",
                },
            },
        },
    ],
}));

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-user-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

const formatPhoneNumber = (value) => {
    const phoneNumber = String(value || '').replace(/\D/g, '');
    if (phoneNumber.length >= 6) {
        const areaCode = phoneNumber.substring(0, 3);
        const firstPart = phoneNumber.substring(3, 6);
        const secondPart = phoneNumber.substring(6, 10);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
    }
    if (phoneNumber.length >= 3) {
        return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3)}`;
    }
    if (phoneNumber.length > 0) {
        return `(${phoneNumber}`;
    }
    return phoneNumber;
};

const UserDialog = ({
    openUserDialog,
    setOpenUserDialog,
    user,
    avatarSrc,
    deployDialogOpen,
    setDeployDialogOpen,
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const isSmallScreen = useIsMobile();
    const dispatch = useDispatch();
    const avatarInputRef = React.useRef(null);
    const [avatarBusy, setAvatarBusy] = useState(false);
    const [avatarError, setAvatarError] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [saving, setSaving] = useState(false);
    const [showError, setShowError] = useState('');
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [errors, setErrors] = useState({
        first_name: '',
        last_name: '',
        username: '',
        phone: '',
    });
    const [form, setForm] = useState({
        first_name: '',
        last_name: '',
        username: '',
        phone: '',
    });

    useEffect(() => {
        if (!openUserDialog) return;
        setEditMode(false);
        setShowError('');
        setErrors({ first_name: '', last_name: '', username: '', phone: '' });
        setForm({
            first_name: user.first_name || '',
            last_name: user.last_name || '',
            username: user.username || '',
            phone: user.phone || '',
        });
    }, [openUserDialog, user.first_name, user.last_name, user.username, user.phone]);

    const handleDeploy = () => {
        setDeployDialogOpen(true);
    };

    const handleAvatarUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            setAvatarError('Avatar must be an image file');
            return;
        }
        setAvatarError('');
        setAvatarBusy(true);
        try {
            const formData = new FormData();
            formData.append('file', file);
            const res = await UPLOAD(api.uploadMyAvatar, formData);
            if (res.error) {
                setAvatarError(res.message || 'Failed to upload avatar');
                return;
            }
            const newKey = res.data?.avatar_s3_key;
            if (newKey) {
                await cacheAvatarBlob(user.id, newKey, file);
                dispatch(setUser({ avatar_s3_key: newKey }));
            }
        } finally {
            setAvatarBusy(false);
            if (avatarInputRef.current) avatarInputRef.current.value = '';
        }
    };

    const handleAvatarDelete = async () => {
        setAvatarError('');
        setAvatarBusy(true);
        try {
            const res = await DELETE(api.deleteMyAvatar);
            if (res.error) {
                setAvatarError(res.message || 'Failed to remove avatar');
                return;
            }
            await clearAvatarCache(user.id);
            dispatch(setUser({ avatar_s3_key: null }));
        } finally {
            setAvatarBusy(false);
        }
    };

    const handleSaveProfile = async () => {
        setShowError('');
        const newErrors = {};
        if (!form.first_name || form.first_name.length < 2 || form.first_name.length > 50) {
            newErrors.first_name = 'First name must be between 2 and 50 characters';
        }
        if (!form.last_name || form.last_name.length < 2 || form.last_name.length > 50) {
            newErrors.last_name = 'Last name must be between 2 and 50 characters';
        }
        const usernameRegex = /^[a-zA-Z0-9_]+$/;
        if (!form.username || form.username.length < 3 || form.username.length > 50) {
            newErrors.username = 'Username must be between 3 and 50 characters';
        } else if (!usernameRegex.test(form.username)) {
            newErrors.username = 'Username must contain only alphanumeric characters and underscores';
        }
        if (form.phone) {
            const phoneDigits = form.phone.replace(/\D/g, '');
            if (phoneDigits.length !== 10) {
                newErrors.phone = 'Please enter a valid 10-digit US phone number';
            }
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        setSaving(true);
        const payload = {
            first_name: form.first_name.trim(),
            last_name: form.last_name.trim(),
            username: form.username.trim(),
            phone: form.phone || null,
        };
        const { status, data, message } = await PATCH(api.updateMyProfile, {}, payload);
        if (status === 200) {
            dispatch(setUser({
                first_name: data.first_name,
                last_name: data.last_name,
                username: data.username,
                phone: data.phone,
                updated_at: data.updated_at,
            }));
            dispatch(updateUsersListUser(data));
            setEditMode(false);
            setShowSuccessToast(true);
        } else {
            setShowError(message || data?.message || 'Failed to update profile.');
        }
        setSaving(false);
    };

    const readOnlyBoxSx = {
        display: 'flex',
        alignItems: 'center',
        p: 1.5,
        borderRadius: 2,
        backgroundColor: isDarkMode ? '#1e293b' : '#fafafa',
        border: isDarkMode ? '1px solid #334155' : '1px solid #e0e0e0',
        fontFamily: '"Space Grotesk", Inter, sans-serif',
        fontSize: '1rem',
        minHeight: '44px',
    };

    const labelSx = {
        fontWeight: 600,
        color: 'text.secondary',
        fontSize: '1.1rem',
        fontFamily: '"Space Grotesk", Inter, sans-serif',
        mb: 0.5,
    };

    return (
        <>
        <Dialog 
            open={openUserDialog} 
            onClose={() => {
                if (saving) return;
                setOpenUserDialog(false);
                setEditMode(false);
            }} 
            maxWidth="sm" 
            fullWidth
            fullScreen={isSmallScreen}
            PaperComponent={isSmallScreen ? undefined : PaperComponent}
            aria-labelledby="draggable-user-dialog-title"
            slotProps={{
                paper: {
                    sx: {
                        backgroundColor: 'background.paper',
                        borderRadius: isSmallScreen ? 0 : undefined,
                        m: isSmallScreen ? 0 : undefined,
                    }
                }
            }}
        >
            <DialogTitle id="draggable-user-dialog-title" sx={{ 
                cursor: isSmallScreen ? 'default' : 'move', 
                backgroundColor: 'background.paper',
                borderBottom: isDarkMode ? '1px solid #334155' : '1px solid #e0e0e0',
            }}>
            </DialogTitle>
            <DialogContent sx={{ p: 0, backgroundColor: 'background.paper' }}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, p: { xs: 2, sm: 3 } }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '120px' }}>
                        <Box sx={{ position: 'relative', mb: 1 }}>
                            <Avatar
                                src={avatarSrc || undefined}
                                sx={{ 
                                    width: 72, 
                                    height: 72, 
                                    fontSize: '1.5rem',
                                    background: isDarkMode
                                        ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
                                        : 'linear-gradient(135deg, #000000 0%, #333333 100%)',
                                    boxShadow: isDarkMode
                                        ? '0 4px 12px rgba(59, 130, 246, 0.3)'
                                        : '0 4px 12px rgba(0, 0, 0, 0.3)',
                                    color: 'white'
                                }}
                            >
                                {!avatarSrc && (
                                    <>{(editMode ? form.first_name : user.first_name)?.charAt(0)}{(editMode ? form.last_name : user.last_name)?.charAt(0)}</>
                                )}
                            </Avatar>
                            {avatarBusy && (
                                <CircularProgress
                                    size={28}
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-14px',
                                        marginLeft: '-14px',
                                    }}
                                />
                            )}
                        </Box>
                        <input
                            ref={avatarInputRef}
                            type="file"
                            accept="image/jpeg,image/png,image/gif,image/webp"
                            hidden
                            onChange={handleAvatarUpload}
                        />
                        <Box sx={{ display: 'flex', gap: 0.5, mb: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                            <Button
                                size="small"
                                startIcon={<PhotoCameraIcon />}
                                onClick={() => avatarInputRef.current?.click()}
                                disabled={avatarBusy}
                                sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                            >
                                {user.avatar_s3_key ? 'Change' : 'Upload'}
                            </Button>
                            {user.avatar_s3_key && (
                                <Button
                                    size="small"
                                    color="error"
                                    startIcon={<DeleteOutlineIcon />}
                                    onClick={handleAvatarDelete}
                                    disabled={avatarBusy}
                                    sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                                >
                                    Remove
                                </Button>
                            )}
                        </Box>
                        {avatarError && (
                            <Typography variant="caption" color="error" sx={{ mb: 1, textAlign: 'center' }}>
                                {avatarError}
                            </Typography>
                        )}
                        <Typography variant="h6" sx={{ 
                            fontWeight: 600, 
                            textAlign: 'center',
                            fontFamily: '"Space Grotesk", Inter, sans-serif',
                            color: 'text.primary'
                        }}>
                            {editMode ? `${form.first_name} ${form.last_name}` : `${user.first_name} ${user.last_name}`}
                        </Typography>
                        <Typography variant="body2" sx={{ 
                            color: 'text.secondary', 
                            fontFamily: '"Space Grotesk", Inter, sans-serif',
                            textAlign: 'center',
                            lineHeight: 1.35,
                        }}>
                            {allRoleLabels(user)}
                        </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, flex: 1 }}>
                        {showError && (
                            <Typography variant="body2" sx={{ color: 'error.main', fontWeight: 600 }}>
                                {showError}
                            </Typography>
                        )}

                        {editMode ? (
                            <>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="First Name"
                                    value={form.first_name}
                                    error={!!errors.first_name}
                                    helperText={errors.first_name}
                                    onChange={(e) => setForm({ ...form, first_name: e.target.value })}
                                />
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Last Name"
                                    value={form.last_name}
                                    error={!!errors.last_name}
                                    helperText={errors.last_name}
                                    onChange={(e) => setForm({ ...form, last_name: e.target.value })}
                                />
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Username"
                                    value={form.username}
                                    error={!!errors.username}
                                    helperText={errors.username}
                                    onChange={(e) => setForm({ ...form, username: e.target.value })}
                                />
                            </>
                        ) : (
                            <Box>
                                <Typography variant="subtitle2" sx={labelSx}>Username</Typography>
                                <Box sx={readOnlyBoxSx}>
                                    <Typography variant="body1" sx={{ fontFamily: '"Space Grotesk", Inter, sans-serif', fontSize: '1rem', color: 'text.primary' }}>
                                        {user.username || 'N/A'}
                                    </Typography>
                                </Box>
                            </Box>
                        )}

                        <Box>
                            <Typography variant="subtitle2" sx={labelSx}>Email</Typography>
                            <Box sx={readOnlyBoxSx}>
                                <Typography variant="body1" sx={{ 
                                    fontFamily: '"Space Grotesk", Inter, sans-serif',
                                    fontSize: '1rem',
                                    color: 'text.primary'
                                }}>
                                    {user.email}
                                </Typography>
                            </Box>
                        </Box>

                        <Box>
                            <Typography variant="subtitle2" sx={labelSx}>Phone</Typography>
                            {editMode ? (
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={form.phone || ''}
                                    error={!!errors.phone}
                                    helperText={errors.phone}
                                    onChange={(e) => setForm({ ...form, phone: formatPhoneNumber(e.target.value) })}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <span style={{ fontSize: '0.9rem' }}>🇺🇸</span>
                                                    <Typography sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.85rem' }}>+1</Typography>
                                                </Box>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            ) : (
                                <Box sx={{
                                    ...readOnlyBoxSx,
                                    gap: 1,
                                }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <span style={{ fontSize: '1rem' }}>🇺🇸</span>
                                        <Typography sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.9rem' }}>
                                            +1
                                        </Typography>
                                    </Box>
                                    <Typography variant="body1" sx={{ 
                                        fontFamily: '"Space Grotesk", Inter, sans-serif',
                                        fontSize: '1rem',
                                        color: 'text.primary'
                                    }}>
                                        {user.phone || 'N/A'}
                                    </Typography>
                                </Box>
                            )}
                        </Box>

                        {!editMode && (
                            <>
                                <Box>
                                    <Typography variant="subtitle2" sx={labelSx}>Created At</Typography>
                                    <Box sx={readOnlyBoxSx}>
                                        <Typography variant="body1" sx={{ fontFamily: '"Space Grotesk", Inter, sans-serif', fontSize: '1rem', color: 'text.primary' }}>
                                            {user.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box>
                                    <Typography variant="subtitle2" sx={labelSx}>Updated At</Typography>
                                    <Box sx={readOnlyBoxSx}>
                                        <Typography variant="body1" sx={{ fontFamily: '"Space Grotesk", Inter, sans-serif', fontSize: '1rem', color: 'text.primary' }}>
                                            {user.updated_at ? new Date(user.updated_at).toLocaleDateString() : 'N/A'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </>
                        )}

                        <Box>
                            <Typography variant="subtitle2" sx={labelSx}>Appearance</Typography>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                p: 1.5,
                                borderRadius: 2,
                                backgroundColor: isDarkMode ? '#1e293b' : '#fafafa',
                                border: isDarkMode ? '1px solid #334155' : '1px solid #e0e0e0',
                                fontFamily: '"Space Grotesk", Inter, sans-serif',
                                fontSize: '1rem',
                                minHeight: '44px'
                            }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                    {isDarkMode ? (
                                        <DarkModeIcon sx={{ fontSize: 18, color: theme.palette.text.secondary }} />
                                    ) : (
                                        <LightModeIcon sx={{ fontSize: 18, color: theme.palette.text.secondary }} />
                                    )}
                                    <Typography variant="body2" sx={{ 
                                        color: theme.palette.text.secondary,
                                        fontSize: '0.875rem',
                                        fontWeight: 500
                                    }}>
                                        {isDarkMode ? 'Dark mode' : 'Light mode'}
                                    </Typography>
                                </Box>
                                <Switch
                                    checked={isDarkMode}
                                    onChange={() => dispatch(toggleTheme())}
                                    size="small"
                                    sx={{
                                        '& .MuiSwitch-switchBase.Mui-checked': {
                                            color: theme.palette.primary.main,
                                        },
                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: theme.palette.primary.main,
                                        },
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ 
                p: 2, 
                borderTop: isDarkMode ? '1px solid #334155' : '1px solid #e0e0e0',
                backgroundColor: 'background.paper',
                gap: 1,
            }}>
                {user.id === '20507bcb-b6f5-4b12-9b57-9aa9de172a24' && (
                    <Button 
                        onClick={handleDeploy} 
                        variant="outlined"
                        sx={{ 
                            borderColor: '#ff6b35',
                            color: '#ff6b35',
                            borderRadius: 2,
                            px: 3,
                            py: 1,
                            fontFamily: '"Space Grotesk", Inter, sans-serif',
                            fontWeight: 600,
                            textTransform: 'none',
                            mr: 'auto',
                            '&:hover': {
                                borderColor: '#ff6b35',
                                backgroundColor: '#ff6b35',
                                color: 'white',
                                transform: 'translateY(-1px)'
                            }
                        }}
                    >
                        Deploy to Server
                    </Button>
                )}
                {editMode ? (
                    <>
                        <Button
                            onClick={() => {
                                setEditMode(false);
                                setShowError('');
                                setErrors({ first_name: '', last_name: '', username: '', phone: '' });
                                setForm({
                                    first_name: user.first_name || '',
                                    last_name: user.last_name || '',
                                    username: user.username || '',
                                    phone: user.phone || '',
                                });
                            }}
                            disabled={saving}
                            variant="outlined"
                            sx={{ textTransform: 'none', borderRadius: 2 }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSaveProfile}
                            disabled={saving}
                            variant="contained"
                            sx={{ 
                                background: isDarkMode
                                    ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
                                    : 'linear-gradient(135deg, #000000 0%, #333333 100%)',
                                borderRadius: 2,
                                px: 3,
                                py: 1,
                                fontFamily: '"Space Grotesk", Inter, sans-serif',
                                fontWeight: 600,
                                textTransform: 'none',
                                color: 'white',
                            }}
                        >
                            {saving ? 'Saving...' : 'Save'}
                        </Button>
                    </>
                ) : (
                    <>
                        <Button
                            onClick={() => setEditMode(true)}
                            variant="outlined"
                            sx={{ textTransform: 'none', borderRadius: 2 }}
                        >
                            Edit Profile
                        </Button>
                        <Button 
                            onClick={() => setOpenUserDialog(false)} 
                            variant="contained"
                            sx={{ 
                                background: isDarkMode
                                    ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
                                    : 'linear-gradient(135deg, #000000 0%, #333333 100%)',
                                borderRadius: 2,
                                px: 3,
                                py: 1,
                                fontFamily: '"Space Grotesk", Inter, sans-serif',
                                fontWeight: 600,
                                textTransform: 'none',
                                boxShadow: isDarkMode
                                    ? '0 4px 12px rgba(59, 130, 246, 0.3)'
                                    : '0 4px 12px rgba(0, 0, 0, 0.3)',
                                color: 'white',
                                '&:hover': {
                                    background: isDarkMode
                                        ? 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)'
                                        : 'linear-gradient(135deg, #1a1a1a 0%, #000000 100%)',
                                    boxShadow: isDarkMode
                                        ? '0 6px 16px rgba(59, 130, 246, 0.4)'
                                        : '0 6px 16px rgba(0, 0, 0, 0.4)',
                                }
                            }}
                        >
                            Close
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
        <Snackbar
            open={showSuccessToast}
            autoHideDuration={3000}
            onClose={() => setShowSuccessToast(false)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert onClose={() => setShowSuccessToast(false)} severity="success" sx={{ width: '100%' }}>
                Profile updated successfully
            </Alert>
        </Snackbar>
        </>
    );
};

const LogoutDialog = ({openLogoutDialog, setOpenLogoutDialog}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const handleLogout = async () => {
        setLoading(true);
        const {status} = await GET(api.logout);
        setLoading(false);
        if (status === 200) {
            dispatch(removeClients());
            dispatch(removeUsers());
            removeLocalAccessTokenAndUser();
            dispatch(removeUser());
            dispatch(removeJobs());
            dispatch(clearSelectedCompany());
        }
        else setError('Something went wrong, please try again later.');
        
    };
    return (
        <Dialog open={openLogoutDialog} onClose={() => setOpenLogoutDialog(false)} maxWidth="xs" fullWidth>
            <DialogTitle>Logout</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Are you sure you want to logout?
                {error && <DialogContentText sx={{ color: 'red' }}>{error}</DialogContentText>}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpenLogoutDialog(false)} sx={{ color: 'black' }}>Cancel</Button>
            <Button onClick={handleLogout} sx={{ color: 'red' }} disabled={loading}>{loading ? 'Logging out...' : 'Logout'}</Button>
        </DialogActions>
        </Dialog>
    );
};

const SIDEBAR_STORAGE_KEY = 'sidebarOpen';
const ACCOUNTING_MENU_STORAGE_KEY = 'accountingMenuOpen';
const JOBS_MENU_STORAGE_KEY = 'jobsMenuOpen';

const getRouteTitle = (pathname, user) => {
    if (pathname.startsWith('/control-center')) return 'Control Center';
    if (pathname.startsWith('/dashboard')) return 'Dashboard';
    if (pathname.startsWith('/clients')) return 'Clients';
    if (pathname.startsWith('/jobs')) return 'Work Orders';
    if (pathname.startsWith('/accounting')) return 'Accounting';
    if (pathname.startsWith('/users')) return 'Users';
    if (pathname.startsWith('/technicians')) return 'Techs/Vendors';
    if (pathname.startsWith('/reminders')) return 'Reminders';
    if (pathname.startsWith('/client-requests')) return 'Requests';
    if (pathname.startsWith('/requests')) return 'Requests';
    if (pathname.startsWith('/notifications')) return 'Notifications';
    if (pathname.startsWith('/alerts')) return 'Alerts';
    if (pathname.startsWith('/calendar')) return 'Calendar';
    if (pathname.startsWith('/map')) return 'Map';
    if (pathname.startsWith('/settings')) return 'Settings';
    return canViewDashboard(user) ? 'Dashboard' : 'Work Orders';
};

const drawerCountBadgeSx = {
    background: 'linear-gradient(135deg, #d32f2f 0%, #ff5252 100%)',
    color: 'white',
    fontWeight: 600,
    boxShadow: '0 2px 4px rgba(211, 47, 47, 0.3)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
};

export default function MainDrawer() {
    const [open, setOpen] = React.useState(() => {
        const saved = localStorage.getItem(SIDEBAR_STORAGE_KEY);
        // Default to true (open) if no saved preference
        return saved === null ? true : saved === 'true';
    });

    // Save drawer state to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem(SIDEBAR_STORAGE_KEY, String(open));
    }, [open]);
    
    const currentRoute = useLocation().pathname;
    const [openTab, setOpenTab] = useState(currentRoute);
    const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
    const [openUserDialog, setOpenUserDialog] = useState(false);
    const [deployDialogOpen, setDeployDialogOpen] = useState(false);
    
    // State for collapsible Accounting menu
    const [accountingMenuOpen, setAccountingMenuOpen] = React.useState(() => {
        const saved = localStorage.getItem(ACCOUNTING_MENU_STORAGE_KEY);
        // Default to false (collapsed) if no saved preference
        return saved === 'true';
    });
    // State for collapsible Jobs menu
    const [jobsMenuOpen, setJobsMenuOpen] = React.useState(() => {
        const saved = localStorage.getItem(JOBS_MENU_STORAGE_KEY);
        // Default to false (collapsed) if no saved preference
        return saved === 'true';
    });

    // Save accounting menu state to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem(ACCOUNTING_MENU_STORAGE_KEY, String(accountingMenuOpen));
    }, [accountingMenuOpen]);
    useEffect(() => {
        localStorage.setItem(JOBS_MENU_STORAGE_KEY, String(jobsMenuOpen));
    }, [jobsMenuOpen]);
    
    const user = useSelector(getUser);
    const { src: avatarSrc } = useUserAvatar(user);
    const selectedCompanyName = useSelector(getSelectedCompanyName);
    const selectedCompanyId = useSelector(getSelectedCompanyId);
    const superAdmin = isSuperAdmin(user);
    const [companyHeader, setCompanyHeader] = React.useState({ name: '', logoUrl: null });
    const clientRequests = useSelector(getClientRequests);
    const { jobs } = useSelector(getJobs);
    const unreadNotificationsCount = useSelector(getUnreadCount);
    const accountingTabCounts = useSelector(getAccountingTabCounts);
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const showDrawerLabels = isMobile || open;
    const showAccounting = canAccessAccounting(user);
    const [bottomTabsConfig, setBottomTabsConfig] = React.useState(() => resolveBottomTabs(user));

    const dispatch = useDispatch();

    useEffect(() => {
        setBottomTabsConfig(resolveBottomTabs(user));
    }, [user]);

    useEffect(() => {
        const refreshBottomTabs = () => setBottomTabsConfig(resolveBottomTabs(user));
        window.addEventListener(MOBILE_BOTTOM_TABS_CHANGED_EVENT, refreshBottomTabs);
        return () => window.removeEventListener(MOBILE_BOTTOM_TABS_CHANGED_EVENT, refreshBottomTabs);
    }, [user]);

    // Poll notifications (and accounting tab counts) every 60 seconds
    useEffect(() => {
        if (!user.id) return;

        dispatch(fetchNotifications());
        if (showAccounting) {
            dispatch(fetchAccountingTabCounts());
        }

        const intervalId = setInterval(() => {
            dispatch(fetchNotifications());
            if (showAccounting) {
                dispatch(fetchAccountingTabCounts());
            }
        }, 60000);

        return () => {
            clearInterval(intervalId);
            dispatch(clearNotifications());
            dispatch(clearAccountingTabCounts());
        };
    }, [user.id, dispatch, showAccounting]);

    // Company name + logo for drawer header (all users in a tenant workspace)
    useEffect(() => {
        if (!user.id) return undefined;

        let cancelled = false;
        const loadCompanyHeader = async () => {
            const res = await GET(api.getCompanyProfile);
            if (cancelled || res.error) return;
            const company = res.data?.company;
            if (!company) return;
            setCompanyHeader({
                name: company.name || '',
                logoUrl: company.logo_download_url || null,
            });
        };

        loadCompanyHeader();
        return () => { cancelled = true; };
    }, [user.id, selectedCompanyId]);

    const companyDisplayName = companyHeader.name || selectedCompanyName || 'Contracting Co.';

    // Get clients, users, client requests and load redux store
    useEffect(() => {
        const getClients = async () => {
            const {data, status} = await GET(api.getClients);
            if (status === 200) {
                const clientList = data.clients || data || [];
                dispatch(setClients({clients: clientList, clientRequests: data.clientRequests || [],})); // data.clients for owner, data for admins and dispatchers etc..
                const colorCompanyId = user.company_id || selectedCompanyId;
                if (colorCompanyId) syncClientColors(colorCompanyId, Array.isArray(clientList) ? clientList : []);
                // Backend now returns a flat list of users (each with roles[]). Splitting by
                // role is done at the selector layer (getAdmins/getDispatchers/etc.).
                dispatch(setUsers({list: data.users || [], technicians: data.technicians || []}));
            }
            else {
                dispatch(setClients({ error: 'Something went wrong, please try again later.'}));
                dispatch(setUsers({ error: 'Something went wrong, please try again later.'}));
            }
        };

        const fetchJobs = async () => {
            const {data, status} = await GET(api.getJobs);
            if (status === 200) dispatch(setJobs({jobs: data.jobs}));
            else dispatch(setJobs({error: 'Something went wrong, please try again later.'}));
        };

        user.id && getClients();
        user.id && fetchJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.id, user.company_id, selectedCompanyId]);

    useEffect(() => {
        setOpenTab(currentRoute);
    }, [currentRoute]);

    const toggleAccordionMenu = (menu) => {
        const isAccounting = menu === 'accounting';
        const currentMenuOpen = isAccounting ? accountingMenuOpen : jobsMenuOpen;

        if (open) {
            const willOpen = !currentMenuOpen;
            if (isAccounting) {
                setAccountingMenuOpen(willOpen);
                if (willOpen) setJobsMenuOpen(false);
            } else {
                setJobsMenuOpen(willOpen);
                if (willOpen) setAccountingMenuOpen(false);
            }
        } else {
            setOpen(true);
            if (isAccounting) {
                setAccountingMenuOpen(true);
                setJobsMenuOpen(false);
            } else {
                setJobsMenuOpen(true);
                setAccountingMenuOpen(false);
            }
        }
    };

    useEffect(() => {
        if (currentRoute.startsWith('/accounting/')) {
            setAccountingMenuOpen(true);
            setJobsMenuOpen(false);
        }
        if (currentRoute.startsWith('/jobs/')) {
            setJobsMenuOpen(true);
            setAccountingMenuOpen(false);
        }
    }, [currentRoute]);

    const navigate = useNavigate();

    const navigateTo = (path) => {
        setOpenTab(path);
        navigate(path);
        if (isMobile) setMobileOpen(false);
    };

    // Super-admin or multi-company member: leave the current company and return to the picker.
    // Clear tenant-scoped domain data so no stale company data lingers.
    const handleSwitchCompany = () => {
        dispatch(removeClients());
        dispatch(removeUsers());
        dispatch(removeJobs());
        dispatch(clearSelectedCompany());
    };

    const canSwitchCompany = superAdmin || (Array.isArray(user.companies) && user.companies.length > 1);

    // Accounting nested routes
    const accountingRoutes = [
        { title: "Ready for Invoicing", path: routes.accountingReadyForInvoicing, countKey: 'ready-for-invoicing' },
        { title: "Invoiced", path: routes.accountingInvoiced },
        { title: "Not QB Invoiced", path: routes.accountingNotQBInvoiced, countKey: 'not-qb-invoiced' },
        { title: "Not Sent to Client", path: routes.accountingNotSentToClient, countKey: 'not-sent-to-client' },
        { title: "Unpaid Invoices", path: routes.accountingOpenInvoices },
        { title: "Paid Invoices", path: routes.accountingPaid },
        { title: "Factored", path: routes.accountingFactored },
        { title: "Non Factored", path: routes.accountingNonFactored },
        { title: "Invoiced/Loss", path: routes.accountingInvoicedLoss },
    ];
    const jobsRoutes = [
        { title: "Priority", path: routes.jobsPriority },
        { title: "Active", path: routes.jobsActive },
        { title: "Job Done", path: routes.jobsJobDone },
        { title: "Archived", path: routes.jobsArchived },
        { title: "All", path: routes.jobsAll },
        ...(canViewDeletedJobs(user) ? [{ title: "Deleted", path: routes.jobsDeleted }] : []),
    ];

    const roleLabels = allRoleLabels(user);

    const isOwnerLike = isManagement(user);
    const showRequests = canAccessRequestsPage(user);
    const showReminders = canAccessPendingJobsTab(user);

    let requestsRoute = null;
    if (showRequests) {
        const jobTechRequestCount = deriveJobTechnicianRequestRows(jobs || []).length;
        const proposalRequestCount = deriveProposalRequestRows(jobs || []).length;
        const partRequestCount = derivePartRequestRows(jobs || []).length;
        const jobUnlockRequestCount = canAccessJobUnlockRequestsTab(user)
            ? deriveJobUnlockRequestRows(jobs || []).length
            : 0;
        const myRequestsCount = !isOwnerLike ? deriveMyRequestRows(jobs || [], user).length : 0;
        const showProposals = canAccessProposalsTab(user);
        const showPartRequests = canAccessPartRequestsTab(user);
        const totalRequestCount = isOwnerLike
            ? (clientRequests?.length || 0) + jobUnlockRequestCount + jobTechRequestCount + partRequestCount + proposalRequestCount
            : showProposals
                ? myRequestsCount + jobTechRequestCount + partRequestCount + proposalRequestCount
                : myRequestsCount + jobTechRequestCount + (showPartRequests ? partRequestCount : 0);
        requestsRoute = { 
            title: "Requests", 
            path: routes.clientRequests, 
            icon: (
                <Badge 
                    badgeContent={totalRequestCount} 
                    color="primary"
                    sx={{
                        '& .MuiBadge-badge': {
                            ...drawerCountBadgeSx,
                            fontSize: '0.75rem',
                            minWidth: '18px',
                            height: '18px',
                            borderRadius: '9px',
                        }
                    }}
                >
                    <ClientRequestsIcon />
                </Badge>
            )
        };
    }

    let remindersRoute = null;
    if (showReminders) {
        const remindersCount = deriveUnassignedPendingJobRows(jobs || []).length;
        remindersRoute = {
            title: "Reminders",
            path: routes.reminders,
            icon: (
                <Badge 
                    badgeContent={remindersCount}
                    invisible={!remindersCount}
                    color="primary"
                    sx={{
                        '& .MuiBadge-badge': {
                            ...drawerCountBadgeSx,
                            fontSize: '0.75rem',
                            minWidth: '18px',
                            height: '18px',
                            borderRadius: '9px',
                        }
                    }}
                >
                    <AlarmIcon />
                </Badge>
            )
        };
    }

    const localRoutes = [
        // { title: "Coming Soon", path: routes.comingSoon, icon: <BusinessIcon /> },
        ...(canViewControlCenter(user) ? [{ title: "Control Center", path: routes.controlCenter, icon: <HubIcon /> }] : []),
        ...(canManageAlerts(user) ? [{ title: "Alerts", path: routes.alerts, icon: <CampaignIcon /> }] : []),
        ...(canViewDashboard(user) ? [{ title: "Dashboard", path: routes.dashboard, icon: <DashboardIcon /> }] : []),
        ...(canAccessClientsPage(user) ? [{ title: "Clients", path: routes.clients, icon: <ClientsIcon /> }] : []),
        {
            title: "Work Orders",
            path: routes.jobs,
            icon: <JobsIcon />,
            isCollapsible: true,
            nestedRoutes: jobsRoutes,
        },
        ...(showAccounting ? [{
            title: "Accounting",
            path: routes.accounting,
            icon: <AccountBalanceIcon />,
            isCollapsible: true,
            nestedRoutes: accountingRoutes
        }] : []),
        ...(canAccessUsersPage(user) ? [{ title: "Users", path: routes.users, icon: <UsersIcon /> }] : []),
        { title: "Techs/Vendors", path: routes.technicians, icon: <TechniciansIcon /> },
        ...(requestsRoute ? [requestsRoute] : []),
        ...(remindersRoute ? [remindersRoute] : []),
        { title: "Notifications", path: routes.notifications, icon: (
            <Badge 
                badgeContent={unreadNotificationsCount} 
                color="error"
                sx={{
                    '& .MuiBadge-badge': {
                        ...drawerCountBadgeSx,
                        fontSize: '0.75rem',
                        minWidth: '18px',
                        height: '18px',
                        borderRadius: '9px',
                    }
                }}
            >
                <NotificationsIcon />
            </Badge>
        ) },
        { title: "Calendar", path: routes.calendar, icon: <CalendarIcon /> },
        { title: "Map", path: routes.map, icon: <MapIcon /> },
    ];

    const profileRoutes = [
        { title: "Settings", path: routes.settings, icon: <SettingsIcon /> },
        { title: "Support", path: routes.support, icon: <SupportIcon /> },
        // { title: "Logout", path: routes.logout, icon: <LogoutIcon /> },
    ];

    const requestsBadgeCount = React.useMemo(() => {
        if (!showRequests) return 0;
        const jobTechRequestCount = deriveJobTechnicianRequestRows(jobs || []).length;
        const proposalRequestCount = deriveProposalRequestRows(jobs || []).length;
        const partRequestCount = derivePartRequestRows(jobs || []).length;
        const jobUnlockRequestCount = canAccessJobUnlockRequestsTab(user)
            ? deriveJobUnlockRequestRows(jobs || []).length
            : 0;
        const myRequestsCount = !isOwnerLike ? deriveMyRequestRows(jobs || [], user).length : 0;
        const showProposals = canAccessProposalsTab(user);
        const showPartRequests = canAccessPartRequestsTab(user);
        return isOwnerLike
            ? (clientRequests?.length || 0) + jobUnlockRequestCount + jobTechRequestCount + partRequestCount + proposalRequestCount
            : showProposals
                ? myRequestsCount + jobTechRequestCount + partRequestCount + proposalRequestCount
                : myRequestsCount + jobTechRequestCount + (showPartRequests ? partRequestCount : 0);
    }, [showRequests, jobs, clientRequests, isOwnerLike, user]);

    const remindersBadgeCount = React.useMemo(() => {
        if (!showReminders) return 0;
        return deriveUnassignedPendingJobRows(jobs || []).length;
    }, [showReminders, jobs]);

    const accountingTotalBadgeCount = React.useMemo(() => (
        accountingRoutes.reduce((sum, route) => {
            if (!route.countKey) return sum;
            return sum + (accountingTabCounts[route.countKey] ?? 0);
        }, 0)
    ), [accountingTabCounts]);

    const bottomNavBadgeCounts = React.useMemo(() => ({
        notifications: unreadNotificationsCount,
        requests: requestsBadgeCount,
        reminders: remindersBadgeCount,
    }), [unreadNotificationsCount, requestsBadgeCount, remindersBadgeCount]);

    const showBottomNav = isMobile && !mobileOpen && bottomTabsConfig.visible && bottomTabsConfig.tabs.length > 0;

    return (
        <Box sx={{display: "flex",background: theme.palette.background.default, minHeight: "100vh", }}>
            <CssBaseline />

            {/* Sidebar */}
            <Drawer
                variant={isMobile ? "temporary" : "permanent"}
                open={isMobile ? mobileOpen : open}
                onClose={() => setMobileOpen(false)}
                ModalProps={{ keepMounted: true }}
                sx={isMobile ? { '& .MuiDrawer-paper': { width: drawerWidth } } : undefined}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
                    <DrawerHeader sx={{ 
                        flexShrink: 0,
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        mb: 1,
                        position: 'relative',
                        justifyContent: showDrawerLabels ? 'flex-start' : 'center',
                    }}>
                        <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1.5,
                            px: showDrawerLabels ? 1.5 : 0,
                            justifyContent: showDrawerLabels ? 'flex-start' : 'center',
                            width: showDrawerLabels ? 'auto' : '100%'
                        }}>
                            <Box 
                                onClick={() => isMobile ? setMobileOpen(false) : setOpen(!open)}
                                sx={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 36,
                                    height: 36,
                                    borderRadius: '8px',
                                    background: isDarkMode ? theme.palette.action.hover : '#e0e0e0',
                                    border: isDarkMode ? `1px solid ${theme.palette.divider}` : '1px solid #bdbdbd',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    overflow: 'hidden',
                                    flexShrink: 0,
                                    '&:hover': {
                                        background: isDarkMode ? theme.palette.action.selected : '#d0d0d0',
                                        borderColor: isDarkMode ? theme.palette.divider : '#999',
                                    }
                                }}>
                                {companyHeader.logoUrl ? (
                                    <Box
                                        component="img"
                                        src={companyHeader.logoUrl}
                                        alt={`${companyDisplayName} logo`}
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            p: 0.25,
                                        }}
                                    />
                                ) : (
                                    <BusinessIcon sx={{ fontSize: 20, color: theme.palette.text.secondary }} />
                                )}
                            </Box>
                            {showDrawerLabels && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, minWidth: 0 }}>
                                    <Typography variant="h6" sx={{ 
                                        fontWeight: 700,
                                        color: theme.palette.text.primary,
                                        fontSize: '0.95rem',
                                        lineHeight: 1.2,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                        {companyDisplayName}
                                    </Typography>
                                    {canSwitchCompany && (selectedCompanyName || selectedCompanyId) ? (
                                        <Chip
                                            label="Switch company"
                                            size="small"
                                            onClick={handleSwitchCompany}
                                            sx={{ width: 'fit-content', height: 20, fontSize: '0.7rem', cursor: 'pointer' }}
                                        />
                                    ) : (
                                        <Typography variant="body2" sx={{ 
                                            fontWeight: 400,
                                            color: theme.palette.text.secondary,
                                            fontSize: '0.75rem',
                                            lineHeight: 1.2,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}>
                                            {user.first_name} {user.last_name}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                        </Box>
                        
                        {!isMobile && (
                        <IconButton 
                            onClick={() => setOpen(!open)} 
                            sx={{
                                position: 'absolute',
                                right: 0,
                                transform: 'translateX(100%)',
                                backgroundColor: isDarkMode ? theme.palette.action.hover : '#e5e7eb',
                                color: theme.palette.text.primary,
                                width: 24,
                                height: 24,
                                borderRadius: '4px',
                                transition: 'all 0.2s ease',
                                zIndex: 1300,
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                "&:hover": {
                                    backgroundColor: isDarkMode ? theme.palette.action.selected : '#d1d5db',
                                    color: theme.palette.text.primary,
                                }
                            }}
                        >
                            <ChevronLeftIcon sx={{ 
                                fontSize: 16,
                                transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
                                transition: 'transform 0.3s ease'
                            }} />
                        </IconButton>
                        )}
                    </DrawerHeader>

                    {/* Core Routes — scrollable; header/footer stay pinned */}
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                        }}
                    >
                    <List>
                        {localRoutes.map((text, index) => (
                            <React.Fragment key={index}>
                                {text.isCollapsible ? (
                                    // Collapsible menu item
                                    <>
                                        {(() => {
                                            const isAccountingMenu = text.path === routes.accounting;
                                            const currentMenuOpen = isAccountingMenu ? accountingMenuOpen : jobsMenuOpen;
                                            return (
                                        <Tooltip 
                                            title={text.title} 
                                            placement="right" 
                                            arrow
                                            disableHoverListener={showDrawerLabels}
                                            slotProps={{
                                                popper: {
                                                    modifiers: [
                                                        {
                                                            name: 'offset',
                                                            options: {
                                                                offset: [0, -8],
                                                            },
                                                        },
                                                    ],
                                                },
                                            }}
                                        >
                                            <ListItem 
                                                sx={{display: "block", mx: 0, my: -0.25}} 
                                                onClick={() => toggleAccordionMenu(isAccountingMenu ? 'accounting' : 'jobs')}
                                            >
                                                <ListItemButton sx={[{
                                                    minHeight: 34, 
                                                    py: 0.5,
                                                    borderRadius: 2,
                                                    backgroundColor: "transparent",
                                                    transition: "all 0.2s ease",
                                                    "&:hover": {
                                                        backgroundColor: isDarkMode ? theme.palette.action.hover : "#e0e0e0",
                                                    },
                                                }, showDrawerLabels ? { px: 2.5, mx: 0.5, justifyContent: "center" } : { px: 2, mx: 0.25, justifyContent: "center" }]}>
                                                    <ListItemIcon sx={[{
                                                        minWidth: 0,
                                                        justifyContent: "center",
                                                        color: theme.palette.text.secondary,
                                                    }, showDrawerLabels ? { mr: 2 } : { mr: "auto" }]}>
                                                        {isAccountingMenu && !currentMenuOpen ? (
                                                            <Badge
                                                                badgeContent={accountingTotalBadgeCount}
                                                                invisible={!accountingTotalBadgeCount}
                                                                color="primary"
                                                                sx={{
                                                                    '& .MuiBadge-badge': {
                                                                        ...drawerCountBadgeSx,
                                                                        fontSize: '0.75rem',
                                                                        minWidth: '18px',
                                                                        height: '18px',
                                                                        borderRadius: '9px',
                                                                    },
                                                                }}
                                                            >
                                                                {text.icon}
                                                            </Badge>
                                                        ) : text.icon}
                                                    </ListItemIcon>
                                                    <ListItemText 
                                                        primary={text.title} 
                                                        sx={[{
                                                            color: theme.palette.text.secondary,
                                                            "& .MuiListItemText-primary": {
                                                                fontWeight: 600,
                                                                fontSize: "0.875rem"
                                                            },
                                                            transition: 'opacity 0.2s ease',
                                                            transitionDelay: showDrawerLabels ? '0.2s' : '0s',
                                                        }, showDrawerLabels ? { opacity: 1 } : { opacity: 0 }]}
                                                    />
                                                    {showDrawerLabels && (currentMenuOpen ? <ExpandLess sx={{ 
                                                        color: theme.palette.text.secondary 
                                                    }} /> : <ExpandMore sx={{ 
                                                        color: theme.palette.text.secondary 
                                                    }} />)}
                                                </ListItemButton>
                                            </ListItem>
                                        </Tooltip>
                                            );
                                        })()}
                                        
                                        {/* Nested items */}
                                        <Collapse
                                            in={(text.path === routes.accounting ? accountingMenuOpen : jobsMenuOpen) && open}
                                            timeout="auto"
                                            unmountOnExit
                                        >
                                            <List component="div" disablePadding>
                                                {text.nestedRoutes.map((nestedRoute, nestedIndex) => (
                                                    <ListItem 
                                                        key={nestedIndex}
                                                        sx={{display: "block", mx: 0, my: -0.5, pl: 2}} 
                                                        onClick={() => navigateTo(nestedRoute.path)}
                                                    >
                                                        <ListItemButton sx={{
                                                            minHeight: 28, 
                                                            py: 0.25,
                                                            pl: 4,
                                                            borderRadius: 2,
                                                            backgroundColor: openTab === nestedRoute.path 
                                                                ? (isDarkMode ? theme.palette.primary.main : "#000") 
                                                                : "transparent",
                                                            transition: "all 0.2s ease",
                                                            "&:hover": {
                                                                backgroundColor: openTab === nestedRoute.path 
                                                                    ? (isDarkMode ? theme.palette.primary.dark : "#000") 
                                                                    : (isDarkMode ? theme.palette.action.hover : "#e0e0e0"),
                                                            },
                                                            mx: 0.5,
                                                        }}>
                                                            <ListItemText 
                                                                primary={
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, width: '100%' }}>
                                                                        <span>{nestedRoute.title}</span>
                                                                        {nestedRoute.countKey && (accountingTabCounts[nestedRoute.countKey] ?? 0) > 0 && (
                                                                            <Chip
                                                                                label={accountingTabCounts[nestedRoute.countKey]}
                                                                                size="small"
                                                                                sx={{
                                                                                    height: 18,
                                                                                    minWidth: 22,
                                                                                    flexShrink: 0,
                                                                                    fontSize: '0.7rem',
                                                                                    borderRadius: '9px',
                                                                                    '& .MuiChip-label': { px: 0.75 },
                                                                                    ...drawerCountBadgeSx,
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </Box>
                                                                }
                                                                sx={{
                                                                    color: openTab === nestedRoute.path 
                                                                        ? (isDarkMode ? theme.palette.primary.contrastText : "white") 
                                                                        : theme.palette.text.secondary,
                                                                    "& .MuiListItemText-primary": {
                                                                        fontWeight: 500,
                                                                        fontSize: "0.8125rem"
                                                                    },
                                                                    my: 0,
                                                                }}
                                                            />
                                                        </ListItemButton>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Collapse>
                                    </>
                                ) : (
                                    // Regular menu item
                                    <Tooltip 
                                        title={text.title} 
                                        placement="right" 
                                        arrow
                                        disableHoverListener={showDrawerLabels}
                                        slotProps={{
                                            popper: {
                                                modifiers: [
                                                    {
                                                        name: 'offset',
                                                        options: {
                                                            offset: [0, -8],
                                                        },
                                                    },
                                                ],
                                            },
                                        }}
                                    >
                                        <ListItem sx={{display: "block", mx: 0, my: -0.25}} onClick={() => navigateTo(text.path)}>
                                            <ListItemButton sx={[{
                                                minHeight: 34, 
                                                py: 0.5,
                                                borderRadius: 2,
                                                backgroundColor: openTab === text.path 
                                                    ? (isDarkMode ? theme.palette.primary.main : "#000") 
                                                    : "transparent",
                                                transition: "all 0.2s ease",
                                                "&:hover": {
                                                    backgroundColor: openTab === text.path 
                                                        ? (isDarkMode ? theme.palette.primary.dark : "#000") 
                                                        : (isDarkMode ? theme.palette.action.hover : "#e0e0e0"),
                                                },
                                            }, showDrawerLabels ? { px: 2.5, mx: 0.5, justifyContent: "center" } : { px: 2, mx: 0.25, justifyContent: "center" }]}>
                                                <ListItemIcon sx={[{
                                                    minWidth: 0,
                                                    justifyContent: "center",
                                                    color: openTab === text.path 
                                                        ? (isDarkMode ? theme.palette.primary.contrastText : "white") 
                                                        : theme.palette.text.secondary,
                                                }, showDrawerLabels ? { mr: 2 } : { mr: "auto" }]}>
                                                    {text.icon}
                                                </ListItemIcon>
                                                <ListItemText 
                                                    primary={text.title} 
                                                    sx={[{
                                                        color: openTab === text.path 
                                                            ? (isDarkMode ? theme.palette.primary.contrastText : "white") 
                                                            : theme.palette.text.secondary,
                                                        "& .MuiListItemText-primary": {
                                                            fontWeight: 600,
                                                            fontSize: "0.875rem"
                                                        },
                                                        transition: 'opacity 0.2s ease',
                                                        transitionDelay: showDrawerLabels ? '0.2s' : '0s',
                                                    }, showDrawerLabels ? { opacity: 1 } : { opacity: 0 }]}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    </Tooltip>
                                )}
                            </React.Fragment>
                        ))}
                    </List>
                    </Box>
                    
                    {/* Profile Routes — pinned footer */}
                    <Box sx={{ flexShrink: 0 }}>
                    <List>
                        {profileRoutes.map((text, index) => (
                            <Tooltip 
                                key={index} 
                                title={text.title} 
                                placement="right" 
                                arrow
                                disableHoverListener={showDrawerLabels}
                                slotProps={{
                                    popper: {
                                        modifiers: [
                                            {
                                                name: 'offset',
                                                options: {
                                                    offset: [0, -8],
                                                },
                                            },
                                        ],
                                    },
                                }}
                            >
                                <ListItem sx={{display: "block", mx: 0, my: -0.25}} onClick={() => {text.title === "Logout" ? setOpenLogoutDialog(true) : navigateTo(text.path);}}>
                                    <ListItemButton sx={[{
                                        minHeight: 34,
                                        py: 0.5,
                                        borderRadius: 2,
                                        backgroundColor: openTab === text.path 
                                            ? (isDarkMode ? theme.palette.primary.main : "#000") 
                                            : "transparent",
                                        transition: "all 0.2s ease",
                                        "&:hover": {
                                            backgroundColor: openTab === text.path 
                                                ? (isDarkMode ? theme.palette.primary.dark : "#000") 
                                                : (isDarkMode ? theme.palette.action.hover : "#e0e0e0"),
                                        },
                                    }, showDrawerLabels ? { px: 2.5, mx: 0.5, justifyContent: "center" } : { px: 2, mx: 0.25, justifyContent: "center" }]}>
                                        <ListItemIcon sx={[{
                                            minWidth: 0,
                                            justifyContent: "center",
                                            color: openTab === text.path 
                                                ? (isDarkMode ? theme.palette.primary.contrastText : "white") 
                                                : theme.palette.text.secondary,
                                        }, showDrawerLabels ? { mr: 2 } : { mr: "auto" }]}>
                                            {text.icon}
                                        </ListItemIcon>
                                        <ListItemText 
                                            primary={text.title}
                                            sx={[{
                                                color: openTab === text.path 
                                                    ? (isDarkMode ? theme.palette.primary.contrastText : "white") 
                                                    : theme.palette.text.secondary,
                                                "& .MuiListItemText-primary": {
                                                    fontWeight: 600,
                                                    fontSize: "0.875rem"
                                                },
                                                transition: 'opacity 0.2s ease',
                                                transitionDelay: showDrawerLabels ? '0.2s' : '0s',
                                            }, showDrawerLabels ? { opacity: 1 } : { opacity: 0 }]}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            </Tooltip>
                        ))}
                        
                        {/* User profile section — avatar always visible */}
                        <Box 
                            onClick={() => setOpenUserDialog(true)}
                            sx={{ 
                                px: showDrawerLabels ? 2 : 1,
                                py: 1.5,
                                borderTop: `1px solid ${theme.palette.divider}`,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s ease',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: showDrawerLabels ? 'flex-start' : 'center',
                                gap: showDrawerLabels ? 1.25 : 0,
                                position: 'relative',
                                overflow: 'hidden',
                                '&:hover': {
                                    backgroundColor: isDarkMode ? theme.palette.action.hover : '#f5f5f5',
                                    '& .user-avatar': {
                                        transform: 'scale(1.05)',
                                        boxShadow: isDarkMode
                                            ? '0 4px 14px rgba(59, 130, 246, 0.35)'
                                            : '0 4px 14px rgba(0, 0, 0, 0.35)',
                                    },
                                    ...(showDrawerLabels && {
                                        '& .user-name': {
                                            color: theme.palette.primary.main,
                                        },
                                        '& .link-icon': {
                                            opacity: 1,
                                            transform: 'translateX(2px)',
                                        },
                                    }),
                                },
                            }}
                        >
                            <Avatar
                                className="user-avatar"
                                src={avatarSrc || undefined}
                                sx={{ 
                                    width: 36, 
                                    height: 36, 
                                    fontSize: '0.875rem',
                                    flexShrink: 0,
                                    background: isDarkMode
                                        ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
                                        : 'linear-gradient(135deg, #000000 0%, #333333 100%)',
                                    boxShadow: isDarkMode
                                        ? '0 2px 8px rgba(59, 130, 246, 0.3)'
                                        : '0 2px 8px rgba(0, 0, 0, 0.3)',
                                    color: 'white',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                }}
                            >
                                {!avatarSrc && (
                                    <>{user.first_name?.charAt(0)}{user.last_name?.charAt(0)}</>
                                )}
                            </Avatar>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    minWidth: 0,
                                    flex: 1,
                                    opacity: showDrawerLabels ? 1 : 0,
                                    maxWidth: showDrawerLabels ? '100%' : 0,
                                    transform: showDrawerLabels ? 'translateX(0)' : 'translateX(-6px)',
                                    transition: 'opacity 0.25s ease, max-width 0.25s ease, transform 0.25s ease',
                                    pointerEvents: showDrawerLabels ? 'auto' : 'none',
                                    overflow: 'hidden',
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                                    <Typography
                                        className="user-name"
                                        variant="body2"
                                        sx={{
                                            fontWeight: 600,
                                            color: theme.palette.text.primary,
                                            fontSize: '0.875rem',
                                            lineHeight: 1.3,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            transition: 'color 0.2s ease',
                                        }}
                                    >
                                        {user.first_name} {user.last_name}
                                    </Typography>
                                    <LinkIcon 
                                        className="link-icon"
                                        sx={{ 
                                            fontSize: '0.8rem',
                                            color: theme.palette.text.secondary,
                                            opacity: 0.45,
                                            flexShrink: 0,
                                            transition: 'all 0.2s ease',
                                        }} 
                                    />
                                </Box>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: '0.7rem',
                                        lineHeight: 1.3,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {roleLabels}
                                </Typography>
                            </Box>
                        </Box>
                        
                        {/* Sign Out Button */}
                        <Box sx={{ px: 1.5, pb: 2 }}>
                            <Button
                                fullWidth
                                onClick={() => setOpenLogoutDialog(true)}
                                startIcon={<LogoutIcon />}
                                sx={{
                                    backgroundColor: isDarkMode ? theme.palette.action.hover : '#e0e0e0',
                                    color: theme.palette.text.secondary,
                                    border: isDarkMode ? `1px solid ${theme.palette.divider}` : '1px solid #bdbdbd',
                                    borderRadius: 2,
                                    py: 1,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '0.875rem',
                                    justifyContent: showDrawerLabels ? 'flex-start' : 'center',
                                    '&:hover': {
                                        backgroundColor: isDarkMode ? theme.palette.action.selected : '#d0d0d0',
                                        borderColor: isDarkMode ? theme.palette.divider : '#999',
                                    }
                                }}
                            >
                                {showDrawerLabels && 'Sign Out'}
                            </Button>
                        </Box>
                    </List>
                    </Box>
                </Box>
            </Drawer>

            {/* Main Content */}
            <Box component="main" sx={{ flexGrow: 1, position: 'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column', minWidth: 0, pb: showBottomNav ? 'calc(56px + env(safe-area-inset-bottom, 0px))' : 0, transition: 'padding-bottom 0.28s ease' }}>
                {isMobile && (
                    <AppBar
                        position="sticky"
                        elevation={0}
                        sx={{
                            bgcolor: 'background.paper',
                            color: 'text.primary',
                            borderBottom: 1,
                            borderColor: 'divider',
                        }}
                    >
                        <Toolbar variant="dense" sx={{ minHeight: 48, px: 1 }}>
                            <IconButton edge="start" onClick={() => setMobileOpen(true)} aria-label="Open menu">
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="subtitle1" sx={{ flexGrow: 1, fontWeight: 700, ml: 1 }}>
                                {getRouteTitle(currentRoute, user)}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                )}
                <Box sx={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
                <LoadScript 
                    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                    libraries={GOOGLE_MAPS_LIBRARIES}
                >
                    {/* Map component - kept mounted but hidden when not active to prevent re-initialization */}
                    {process.env.REACT_APP_GOOGLE_MAPS_API_KEY && (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                visibility: currentRoute === routes.map ? 'visible' : 'hidden',
                                display: currentRoute === routes.map ? 'block' : 'none',
                                zIndex: currentRoute === routes.map ? 1 : 0,
                            }}
                        >
                            <Map />
                        </Box>
                    )}
                    
                    {/* Other routes */}
                    <Box
                        sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                            display: currentRoute === routes.map ? 'none' : 'block',
                        }}
                    >
                        <Routes>
                            {/* <Route path={routes.comingSoon} element={<ComingSoon />} /> */}
                            <Route path={routes.controlCenter} element={canViewControlCenter(user) ? <ControlCenter /> : <Navigate to={canViewDashboard(user) ? routes.dashboard : routes.jobs} replace />} />
                            <Route path={routes.alerts} element={canManageAlerts(user) ? <Alerts /> : <Navigate to={routes.notifications} replace />} />
                            <Route path={routes.dashboard} element={canViewDashboard(user) ? <Dashboard /> : <Navigate to={routes.jobs} replace />} />
                            <Route path={routes.notifications} element={<Notifications />} />
                            <Route path={routes.map} element={<Box />} /> {/* Placeholder route - Map rendered separately */}
                            <Route path={routes.calendar} element={<Calendar />} />
                            <Route path={routes.clients} element={canAccessClientsPage(user) ? <Clients /> : <Navigate to={routes.jobsAll} replace />} />
                            <Route path={routes.jobs} element={<Navigate to={routes.jobsAll} replace />} />
                            <Route path={routes.jobsAll} element={<Jobs />} />
                            <Route path={routes.jobsActive} element={<Jobs />} />
                            <Route path={routes.jobsArchived} element={<Jobs />} />
                            <Route path={routes.jobsJobDone} element={<Jobs />} />
                            <Route path={routes.jobsPriority} element={<Jobs />} />
                            <Route path={routes.jobsDeleted} element={canViewDeletedJobs(user) ? <Jobs /> : <Navigate to={routes.jobsAll} replace />} />
                            {canAccessUsersPage(user) && <Route path={routes.users} element={<Users />} />}
                            <Route path={routes.technicians} element={<Technicians />} />
                            {canAccessRequestsPage(user) && <Route path={routes.clientRequests} element={<Requests />} />}
                            {canAccessPendingJobsTab(user) && <Route path={routes.reminders} element={<Reminders />} />}
                            {/* Accounting routes - accessible by owner, general_manager, accountant, and admin */}
                            {showAccounting && (
                                <>
                                    <Route path={routes.accounting} element={<Navigate to={routes.accountingReadyForInvoicing} replace />} />
                                    <Route path={routes.accountingReadyForInvoicing} element={<Accounting />} />
                                    <Route path={routes.accountingInvoiced} element={<Accounting />} />
                                    <Route path={routes.accountingNotQBInvoiced} element={<Accounting />} />
                                    <Route path={routes.accountingNotSentToClient} element={<Accounting />} />
                                    <Route path={routes.accountingOpenInvoices} element={<Accounting />} />
                                    <Route path={routes.accountingPaid} element={<Accounting />} />
                                    <Route path={routes.accountingFactored} element={<Accounting />} />
                                    <Route path={routes.accountingNonFactored} element={<Accounting />} />
                                    <Route path={routes.accountingInvoicedLoss} element={<Accounting />} />
                                </>
                            )}
                            <Route path={routes.settings} element={<Settings />} />
                            {/* <Route path={routes.support} element={<Support />} />
                            <Route path={routes.logout} element={<Logout />} />*/}
                            <Route path="*" element={<Navigate to={canViewDashboard(user) ? routes.dashboard : routes.jobsAll} replace />} />
                        </Routes>
                    </Box>
                </LoadScript>
                </Box>
            </Box>

            {isMobile && (
                <MobileBottomNav
                    tabs={bottomTabsConfig.tabs}
                    visible={showBottomNav}
                    currentPath={currentRoute}
                    onNavigate={navigateTo}
                    badgeCounts={bottomNavBadgeCounts}
                />
            )}

            {/* Dialogs */}
            <LogoutDialog openLogoutDialog={openLogoutDialog} setOpenLogoutDialog={setOpenLogoutDialog} />
            <UserDialog 
                openUserDialog={openUserDialog} 
                setOpenUserDialog={setOpenUserDialog} 
                user={user}
                avatarSrc={avatarSrc}
                deployDialogOpen={deployDialogOpen}
                setDeployDialogOpen={setDeployDialogOpen}
            />
            <DeployLogsDialog 
                open={deployDialogOpen} 
                onClose={() => setDeployDialogOpen(false)} 
            />
        </Box>
    );
}
